import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import Catalog from "@/pages/Catalog";
import ProductDetail from "@/pages/ProductDetail";
import Checkout from "@/pages/Checkout";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import DownloadPage from "@/pages/DownloadPage";
import Services from "@/pages/Services";
import Support from "@/pages/Support";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import FAQ from "@/pages/FAQ";
import Legal from "@/pages/Legal";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminDashboard from "@/pages/admin/AdminDashboard";

const withLayout = (el) => <Layout>{el}</Layout>;

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-right" theme="dark" richColors />
        <Routes>
          <Route path="/" element={withLayout(<Home />)} />
          <Route path="/products" element={withLayout(<Catalog />)} />
          <Route path="/products/:id" element={withLayout(<ProductDetail />)} />
          <Route path="/checkout/:id" element={withLayout(<Checkout />)} />
          <Route path="/payment/success" element={withLayout(<PaymentSuccess />)} />
          <Route path="/payment/cancel" element={withLayout(<PaymentCancel />)} />
          <Route path="/download/:order/:token" element={withLayout(<DownloadPage />)} />
          <Route path="/services" element={withLayout(<Services />)} />
          <Route path="/services/:slug" element={withLayout(<Services />)} />
          <Route path="/support" element={withLayout(<Support />)} />
          <Route path="/about" element={withLayout(<About />)} />
          <Route path="/contact" element={withLayout(<Contact />)} />
          <Route path="/faq" element={withLayout(<FAQ />)} />
          <Route path="/legal/:slug" element={withLayout(<Legal />)} />
          <Route path="/admin" element={<AdminLogin />} />
          <Route path="/admin/dashboard" element={<AdminDashboard />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
